export const actionTypes = {
  // Dark Mode
  TOGGLE_DARK_MODE: "TOGGLE_DARK_MODE",
};
